import React from 'react';

interface EditIconButtonProps {
  title?: string;
  onClick: () => void;
  className?: string;
  iconName?: 'edit' | 'check';
  disable?: boolean;
}

const CommonEditIconButton = (props: EditIconButtonProps) => {
  const { title = '변경', className, onClick = () => {}, iconName = 'edit', disable = false } = props;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`edit-icon-btn ${iconName} ${className || ''}`}
      disabled={disable}
    >
      {title}
    </button>
  );
};

export default CommonEditIconButton;
